/* eslint-disable */
export default {
  topic: 'Titel der Besprechung',
} as const;

// @key: @#@"topic"@#@ @source: @#@"Meeting title"@#@
